import React, { useState, useEffect } from 'react';
import { Form, Select, Button, Space, message } from 'antd';
import { useCompanyCode } from 'hooks';
import { CompanyEditModal, FileViewerModal } from 'components/molecules';
import { usePopupManager } from 'react-popup-manager';
import {  DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { isFileViewer } from 'utils/file-utils';
import { SERVER_URL } from 'commons/constants';
import axios from 'axios';
import { endpoints } from 'services';

interface FormItemProps {
  form: any;
  company_srl: number;
  view_info?: boolean;
  required: boolean;
  onSelected?: (value: string|number, option: any) => void;
}

const CompanyFormItem = ({form, company_srl, view_info = false, required, onSelected}: FormItemProps): React.ReactElement => {
  /* ======================================================
   * variables
   * ====================================================== */
  const [ searchValue, setSearchValue ] = useState<string>();
  const [ company, setCompany ] = useState<number>(company_srl);
  const [ companyInfo, setCompanyInfo] = useState<CompanyCodeListDto>();  
  const { open } = usePopupManager();  
  /* ======================================================
  * hooks
  * ====================================================== */

  const { codeList, refetch } = useCompanyCode({params: {searchValue, company}});  

  /* ======================================================
  * events
  * ====================================================== */  
  
  const onClickRegister = () => {
    open(CompanyEditModal, {
      id: 0,
      onClose: (isOk, id) => {
        if (isOk) {
          refetch();          
          form.setFieldValue('company_srl', id); 
        };
      },
    });     
  }

  const onSelectedItem = (value: string|number, option: any) => {
    setCompanyInfo(option);
    if (onSelected) onSelected(value, option);
  }



  const onDownload = (fileSeq:number, fileName: string): void => {
    axios({
      url: SERVER_URL + endpoints.file.download + '?file_id=' + fileSeq,
      method: 'get',
      responseType: 'blob',
    })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
      })
      .catch(() => {
        message.error('파일 다운로드 중 에러가 발생했습니다.', 1);
      });
    };

    const onOpenFileViewer = (fileId: number, fileName: string, seq: number, gubun: string) => {
      open(FileViewerModal, {
        fileid: fileId,
        filename: fileName,
        seq: seq,
        gubun: gubun,
        editable: false,
        onClose: (isOk, seq, gubun, files) => {
          if (isOk) {};
        },
      });   
     } 

  /* ======================================================
   * effects
   * ====================================================== */
  useEffect(() => {
    setCompany(company_srl);
    if (company_srl > 0) form.setFieldValue('company_srl', company_srl);
}, [company_srl])


useEffect(() => {
  setCompanyInfo(undefined);
  if (!!codeList) {
    const info = codeList.find((item) => item.value === form.getFieldValue('company_srl'));
    if (!!info) {
      setCompanyInfo(info);
      if (onSelected) onSelected(info.value, info);
    }
  }
}, [codeList]);

  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <>
      <Form.Item name="company_srl" style={{ width:'180px', display: 'inline-block', marginRight: '10px' }} rules={[{ required: required, message: '' }]}>
        <Select 
          placeholder="고객사 선택" 
          options={codeList} 
          virtual={false}
          showSearch={true} 
          onSearch={(value) => {
            setCompany(0);
            setSearchValue(value);
          }}
          optionFilterProp="label"     
          //filterOption={selectBoxFilterOption}   
          onSelect={onSelectedItem}                     
        />                
      </Form.Item>   
      <Button onClick={onClickRegister} type="primary" style={{ display: 'inline-block'}}>고객사 등록</Button>
      {view_info && companyInfo && (
        <Space style={{marginLeft:'10px'}}>
          {companyInfo.business_number_file_id > 0 && (
            <>
              <Button onClick={()=>{onDownload(companyInfo.business_number_file_id, companyInfo.business_number_file_name)}} shape="round" icon={<DownloadOutlined />} size='small' style={{padding:'0px 5px'}}/>
              {isFileViewer(companyInfo.business_number_file_name) && (<Button onClick={()=>{onOpenFileViewer(companyInfo.business_number_file_id, companyInfo.business_number_file_name, companyInfo.value, 'identity')}} shape="round" icon={<SearchOutlined />} size='small' style={{padding:'0px 5px'}}/>)}                                   
            </>
          )}
          <label>{'선납금: '+companyInfo.money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+' 포인트: '+companyInfo.point.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}</label>
        </Space>
      )}      
    </>
  );
};

export default CompanyFormItem;
